import * as React from 'react'
import { t } from 'i18next'
import { Link } from 'widgets-for-react'

export const GetCookiebarContent = (type: 'iframe' | 'media' | 'hubspot_form'): JSX.Element => {
  switch (type) {
    case 'iframe':
      return (
        <>
          {t('CookiesPlaceholder:Text')}{' '}
          <Link to={t('CookiesPlaceholder:LinkToCookies')}>{t('CookiesPlaceholder:LinkLabel')}</Link>.
        </>
      )
    case 'hubspot_form':
      return (
        <>
          {t('CookiesPlaceholder:Text')}{' '}
          <Link to={t('CookiesPlaceholder:LinkToCookies')}>{t('CookiesPlaceholder:LinkLabel')}</Link>.
        </>
      )
    case 'media':
      return (
        <>
          {t('CookiesPlaceholder:Text')}{' '}
          <Link to={t('CookiesPlaceholder:LinkToCookies')}>{t('CookiesPlaceholder:LinkLabel')}</Link>.
        </>
      )
    default:
      return <>{t('CookiesPlaceholder:Text')}</>
  }
}

export const GetCookiebarButton = (type: 'iframe' | 'media' | 'hubspot_form'): string => {
  switch (type) {
    case 'iframe':
      return t('CookiesPlaceholder:AcceptCookies')
    case 'hubspot_form':
      return t('CookiesPlaceholder:AcceptCookies')
    case 'media':
      return t('CookiesPlaceholder:AcceptCookies')
    default:
      return t('CookiesPlaceholder:AcceptCookies')
  }
}
